export enum DocumentTypeScan {
  PASSPORT = 'passport',
  BOARDING_PASS = 'boardingPass',
}

export enum ResultModalSelect {
  CLOSED = 1,
  ACCEPT = 2,
}

export enum TypeLoading {
  FOOTER_LOADING,
  COMPONENT_LOADING,
  FULL_LOADING,
}

export enum SeatDisplayStatus {
  AVAILABLE = 0,
  DISABLED = 2,
}

export type TypeLoadingGif = 'FOOTER_LOADING' | 'COMPONENT_LOADING' | 'FULL_LOADING';

export enum OperatingCarrier {
  AM = 'AM',
}

export const DEFAULT_CURRENCY_CODE = 'MXN';
